import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';

@Directive({
  selector: '[appSearch]'
})
export class SearchDirective {
  @Output() search: EventEmitter<string> = new EventEmitter<string>();

  constructor(el: ElementRef) {
    fromEvent(el.nativeElement, 'keyup')
    .pipe(
      filter(Boolean),
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => {
        this.search.emit(el.nativeElement.value);
      })
    ).subscribe();
  }
}
